module.exports = __webpack_public_path__ + "static/img/2023_9_8_2.22c802f1.22c802f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_2.22c802f1.png
// module id = tnd/
// module chunks = 0